import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Params } from '@angular/router';
import { UmbracoLink } from '@models/umbraco.model';
import { WithParamsPipe } from '../pipes/with-params.pipe';
import { NgClass, NgStyle } from '@angular/common';
import { InterceptLinksDirective } from '../../intercept-links/intercept-links.directive';

@Component({
    selector: 'app-link',
    templateUrl: './link.component.html',
    styleUrls: ['./link.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [InterceptLinksDirective, NgClass, NgStyle, WithParamsPipe]
})
export class LinkComponent {
    @Input()
    public readonly link: UmbracoLink;

    @Input()
    public readonly styleClass: string = '';

    @Input()
    public readonly inlineStyle: Partial<CSSStyleDeclaration> | null;

    @Input()
    public readonly cover: boolean = false;

    @Input()
    public readonly queryParams?: Params | null;

    @Input()
    public readonly label?: string;

    @Output()
    public readonly focusEvent = new EventEmitter<Event>();
}
